import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

interface DuplicateEmployeeTemplateInput {
  uuid: string;
  name: string;
}

export const duplicateEmployeeTemplate = async (uuid: string, name: string) => {
  const response = await CustomAxios.post(`/employee_templates/${uuid}/duplicate_template`, {
    uuid,
    name,
  });
  return response.data;
};

export function useDuplicateEmployeeTemplate(onSuccessCallback: (uuid: string) => void) {
  return useMutation({
    mutationFn: ({ uuid, name }: DuplicateEmployeeTemplateInput) => duplicateEmployeeTemplate(uuid, name),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.allEmployeeTemplates],
      });
      onSuccessCallback(data.uuid);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to duplicate the employee template. Please try again and contact support if the problem persists.');
      }
    },
  });
}
